import React, { isValidElement } from "react";
import clsx from "clsx";
import { Col, Row } from "react-bootstrap";

import { RowLabel, RowValue, Skeleton } from "components";
import { checkIfKeyExist } from "helpers";
import { useLoader } from "hooks";


export type StripedColumnDataType = {
	label?: React.ReactNode | JSX.Element | string;
	value?: React.ReactNode | JSX.Element;
	labelCol?: number;
	valueCol?: number;
	component?: JSX.Element;
	rowValueClassName?: string;
	className?: string;
};

type StripedColumnProps = {
	columnData: StripedColumnDataType;
	colsQty?: number;
	isLoading?: boolean;
	isEditForm?: boolean;
	valueContainerClassName?: string;
};

export const StripedColumn = ({
	columnData,
	colsQty = 1,
	isLoading,
	isEditForm,
	valueContainerClassName,
}: StripedColumnProps) => {
	const Loader = useLoader?.(isLoading);

	const mainBsColSize = 12 / colsQty;

	const isLabelKeyExist = checkIfKeyExist(columnData, "label");
	const isValueKeyExist = checkIfKeyExist(columnData, "value");

	return (
		<Col sm={mainBsColSize}>
			<Row>
				{isLabelKeyExist && (
					<Col
						sm={columnData?.labelCol || (!isValueKeyExist ? 12 : 5)}
					>
						<RowLabel content={columnData?.label} />
					</Col>
				)}

				{isValueKeyExist && (
					<Col
						sm={columnData?.valueCol || (!isLabelKeyExist ? 12 : 7)}
						className={clsx(
							valueContainerClassName,
							"d-flex align-items-center",
						)}
					>
						{isEditForm && isValidElement(columnData?.component) ? (
							columnData?.component
						) : (
							<Loader
								skeleton={<Skeleton variant="text" />}
								component={
									<RowValue
										className={clsx(
											columnData.rowValueClassName,
											"w-100",
										)}
										content={columnData?.value}
									/>
								}
							/>
						)}
					</Col>
				)}
			</Row>
		</Col>
	);
};
